import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MerchantInfo } from 'src/app/views/partners/interfaces';
import { environment } from 'src/environments/environment';

@Component({
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  selector: 'app-partners-card',
  templateUrl: './partners-card.component.html',
  styleUrl: './partners-card.component.scss'
})
export class PartnersCardComponent {
  constructor(private router: Router) {}
  @Input() partner!: MerchantInfo;
  @Input() fontSizeForText!: number;
  gcsDefaultImageUrl = `${environment.defaultMerchantLogoURL}/partner-images/default`;

  setDefaultImage(event: Event) {
    (event.target as HTMLImageElement).src = this.gcsDefaultImageUrl;
  }

  partnerDetails(partner: MerchantInfo) {
    this.router.navigate([`partners/${partner.name}`]).catch(() => {});
  }
}
